import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc12e02c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = { style: {"font-family":"'syncopate'","margin-right":".5rem","text-transform":"uppercase"} }
const _hoisted_4 = {
  href: "https://docs.houndrace.com/houndrace-docs/houndrace-nfts/hound-nfts",
  target: "_blank"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Edit Pack Name ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" FILTER ")
const _hoisted_8 = { class: "sort-by" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" RESET ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" SEARCH ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("No hounds found for the current query.")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("RESET FILTERS?")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" You don't currently own any hounds. Acquire one to start your racing career. ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Connect with Metamask in order to view your hounds. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_info_icon = _resolveComponent("info-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_icon_wrapper = _resolveComponent("n-icon-wrapper")!
  const _component_edit_icon = _resolveComponent("edit-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_Save = _resolveComponent("Save")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_caret_down = _resolveComponent("caret-down")!
  const _component_n_radio = _resolveComponent("n-radio")!
  const _component_n_radio_group = _resolveComponent("n-radio-group")!
  const _component_n_slider = _resolveComponent("n-slider")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_arrow_up = _resolveComponent("arrow-up")!
  const _component_n_radio_button = _resolveComponent("n-radio-button")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_reset_icon = _resolveComponent("reset-icon")!
  const _component_search_icon = _resolveComponent("search-icon")!
  const _component_hound_list_item = _resolveComponent("hound-list-item")!
  const _component_n_pagination = _resolveComponent("n-pagination")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_divider = _resolveComponent("n-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_space, {
      justify: "space-between",
      align: "center",
      style: {"padding":"1.5rem"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_n_h3, {
            class: "thick-text",
            style: {"margin-bottom":"0","display":"inline-block"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.packName), 1)
            ]),
            _: 1
          }),
          _createElementVNode("a", _hoisted_4, [
            _createVNode(_component_n_icon_wrapper, {
              "border-radius": "100%",
              size: "14",
              style: {"margin-left":".1rem","background":"transparent","border":"1px solid white"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_icon, {
                  color: "white",
                  size: "10"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_info_icon)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_n_popover, {
            onClickoutside: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNamePopover = false)),
            show: _ctx.showNamePopover,
            trigger: "manual",
            placement: "bottom-start"
          }, _createSlots({
            header: _withCtx(() => [
              _createVNode(_component_n_text, null, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_n_space, { vertical: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_form, {
                    model: _ctx.nameModel,
                    ref: "nameFormRef",
                    onSubmit: _withModifiers(_ctx.updateName, ["prevent"]),
                    rules: _ctx.nameRules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_form_item, {
                        path: "name",
                        "show-label": false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_input, {
                            placeholder: "Pack Name",
                            value: _ctx.nameModel.name,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nameModel.name) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_space, { justify: "right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_button, { "attr-type": "submit" }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_n_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Save)
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "onSubmit", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, [
            (_ctx.ethReactive.initialized)
              ? {
                  name: "trigger",
                  fn: _withCtx(() => [
                    _createVNode(_component_n_button, {
                      size: "tiny",
                      circle: "",
                      ghost: "",
                      style: {"margin-left":".25rem"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNamePopover = !_ctx.showNamePopover))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_edit_icon)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                }
              : undefined
          ]), 1032, ["show"])
        ]),
        _createVNode(_component_n_popover, {
          trigger: "click",
          placement: "bottom-end"
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_n_form, {
              model: _ctx.filtersModel,
              ref: "formRef",
              onSubmit: _withModifiers(_ctx.search, ["prevent"]),
              style: {"max-width":"80vw"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_form_item, {
                  label: "Name",
                  path: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.filtersModel.title,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtersModel.title) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  label: "Gender",
                  path: "gender"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_radio_group, {
                      value: _ctx.filtersModel.gender,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtersModel.gender) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_space, { justify: "space-between" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderTypes, (gender, i) => {
                              return (_openBlock(), _createBlock(_component_n_radio, {
                                key: i,
                                value: gender.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(gender.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  label: "Min Stamina",
                  path: "stamina"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_slider, {
                      value: _ctx.filtersModel.minStamina,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtersModel.minStamina) = $event)),
                      step: 5,
                      min: 0,
                      max: 100
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_n_form_item, {
                    label: "Sort by",
                    path: "sort"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_select, {
                        value: _ctx.filtersModel.sort,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filtersModel.sort) = $event)),
                        options: _ctx.sortTypes
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, { path: "order" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_radio_group, {
                        value: _ctx.filtersModel.order,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filtersModel.order) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_radio_button, {
                            ghost: "",
                            value: "ASC"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_up)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_n_radio_button, { value: "DESC" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_down)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_n_form_item, { "show-feedback": false }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_space, {
                      justify: "right",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_button, { onClick: _ctx.resetFilters }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_n_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_reset_icon)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_n_button, { "attr-type": "submit" }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_n_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_search_icon)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "onSubmit"])
          ]),
          _: 2
        }, [
          (_ctx.ethReactive.initialized)
            ? {
                name: "trigger",
                fn: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    size: "large",
                    text: ""
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_n_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_caret_down)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ])
              }
            : undefined
        ]), 1024)
      ]),
      _: 1
    }),
    (_ctx.ethReactive.initialized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_n_grid, {
            cols: "12",
            "x-gap": "24",
            "y-gap": "24",
            "item-responsive": "",
            responsive: "screen"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_gi, {
                span: "12",
                class: "hounds-table"
              }, {
                default: _withCtx(() => [
                  (_ctx.hounds.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hounds, (hound) => {
                          return (_openBlock(), _createBlock(_component_hound_list_item, {
                            onRefillStamina: _ctx.resetHounds,
                            key: hound.id,
                            hound: hound
                          }, null, 8, ["onRefillStamina", "hound"]))
                        }), 128)),
                        _createVNode(_component_n_space, { justify: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_pagination, {
                              page: _ctx.page,
                              "onUpdate:page": [
                                _cache[8] || (_cache[8] = ($event: any) => ((_ctx.page) = $event)),
                                _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePagination($event)))
                              ],
                              "page-size": _ctx.pageSize,
                              "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pageSize) = $event)),
                              "item-count": _ctx.totalHounds,
                              "show-size-picker": "",
                              "page-sizes": [5, 10, 25, 50],
                              "page-slot": 7,
                              style: {"margin":"2.5rem 0"},
                              "onUpdate:pageSize": _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePagination($event, true)))
                            }, null, 8, ["page", "page-size", "item-count"])
                          ]),
                          _: 1
                        })
                      ]))
                    : (!_ctx.commitedFiltersEmpty)
                      ? (_openBlock(), _createBlock(_component_n_alert, {
                          key: 1,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_space, { justify: "space-between" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_n_text, null, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_n_button, {
                                  type: "primary",
                                  onClick: _ctx.resetFilters,
                                  text: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_14
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_n_alert, {
                          key: 2,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_n_alert, {
          key: 1,
          title: "Allow Connection",
          type: "warning"
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })),
    _createVNode(_component_n_divider)
  ]))
}